import { HttpClient, HttpParams } from '@angular/common/http';
import { computed, inject, Injectable, signal } from '@angular/core';
import { HttpUtils } from 'app/shared/http-utils';
import { catchError, map, tap } from 'rxjs';
import { Facet, FacetAlias } from './facet';
import { FacetModel } from './facet.model';
import { FacetsResponse } from './facets-response';
import { ErrorHandlerService } from 'app/shared/error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class FacetService {
  private http = inject(HttpClient);
  private userFacetTypesApiUrl = HttpUtils.getApiUrl('/lenses/v1/lense/user');
  private allFacetTypesApiUrl = HttpUtils.getApiUrl('/lenses/v1/lense');
  private errorService = inject(ErrorHandlerService);
  readonly userFacetTypes = signal<Facet[]>([]);
  readonly allFacetTypes = signal<Facet[]>([]);
  readonly facetModels = signal<FacetModel[]>([]);
  readonly userNoChapterFacetTypes = computed(() =>
    this.userFacetTypes().filter((facet) => facet.alias !== FacetAlias.chapter),
  );

  getUserFacetTypes() {
    return this.http.get<Facet[]>(this.userFacetTypesApiUrl).pipe(
      tap((facets) => this.userFacetTypes.set(facets.sort((a, b) => a.id - b.id))),
      catchError((err) => this.errorService.handle(err)),
    );
  }

  getAllFacetTypes() {
    return this.http.get<Facet[]>(this.allFacetTypesApiUrl).pipe(
      tap((facets) => this.allFacetTypes.set(facets)),
      catchError((err) => this.errorService.handle(err)),
    );
  }

  getAllByFacet(facet: Facet) {
    const params = new HttpParams().set('lenseId', facet.id);
    return this.http.get<FacetsResponse<FacetModel>>(`${this.userFacetTypesApiUrl}`, { params }).pipe(
      map((response) => response.data),
      tap((facetModels) => this.facetModels.set(facetModels)),
      catchError((err) => this.errorService.handle(err)),
    );
  }
}
